module.exports = __webpack_public_path__ + "img/arrow-left-dark.efd61c59.svg";